export default "__VITE_ASSET__CQo0pUd2__"